<div >
    <img mat-dialog-content [src]="image">
</div>
<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ translations.CLOSE }}</button>
</div>
